document.addEventListener("DOMContentLoaded", function () {

  const toggle = document.getElementById("menuToggle");
  const menu = document.getElementById("fullscreenMenu");
  const header = document.getElementById("mainHeader");

  if (toggle && menu) {
    // The toggle is a <div>; give it button semantics so keyboard users can
    // open the menu now that its links are hidden while it's closed.
    toggle.setAttribute("role", "button");
    toggle.setAttribute("tabindex", "0");
    toggle.setAttribute("aria-label", "Menu");
    toggle.setAttribute("aria-controls", "fullscreenMenu");
    toggle.setAttribute("aria-expanded", "false");

    const toggleMenu = () => {
      toggle.classList.toggle("active");
      menu.classList.toggle("active");
      document.body.classList.toggle("menu-open");
      toggle.setAttribute("aria-expanded", menu.classList.contains("active"));
    };

    toggle.addEventListener("click", toggleMenu);

    toggle.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        toggleMenu();
        if (menu.classList.contains("active")) {
          const firstLink = menu.querySelector("a");
          if (firstLink) firstLink.focus();
        }
      }
    });

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && menu.classList.contains("active")) {
        toggleMenu();
        toggle.focus();
      }
    });
  }

  let lastScroll = 0;

  window.addEventListener("scroll", function () {
    const currentScroll = window.pageYOffset;

    if (header) {
      if (currentScroll > 30) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }

    lastScroll = currentScroll;
  });

});
